export default __webpack_public_path__ + "static/recognition-mob-49fd6a51246f41e9a4925be420a607bb.jpg";